export default {
    topics: [
        {
            title: ' BuildOutputNavTree ',
            href: 'sm-builder-BuildOutputNavTree.html',
            attributes: { 'data-id': 'sm-builder-BuildOutputNavTree' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-BuildOutputNavTree-d66e143',
            topics: [],
        },
        {
            title: ' BuildOutputSchema ',
            href: 'sm-builder-BuildOutputSchema.html',
            attributes: { 'data-id': 'sm-builder-BuildOutputSchema' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-BuildOutputSchema-d66e151',
            topics: [],
        },
        {
            title: ' BuildSchema ',
            href: 'sm-builder-BuildSchema.html',
            attributes: { 'data-id': 'sm-builder-BuildSchema' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-BuildSchema-d66e159',
            topics: [],
        },
        {
            title: ' BuildSchemaFromId ',
            href: 'sm-builder-BuildSchemaFromId.html',
            attributes: { 'data-id': 'sm-builder-BuildSchemaFromId' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-BuildSchemaFromId-d66e167',
            topics: [],
        },
        {
            title: ' BuildSqlSchemaDiff ',
            href: 'sm-builder-BuildSqlSchemaDiff.html',
            attributes: { 'data-id': 'sm-builder-BuildSqlSchemaDiff' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-BuildSqlSchemaDiff-d66e175',
            topics: [],
        },
        {
            title: ' BuildUpdateOneSchemaDiff ',
            href: 'sm-builder-BuildUpdateOneSchemaDiff.html',
            attributes: { 'data-id': 'sm-builder-BuildUpdateOneSchemaDiff' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-BuildUpdateOneSchemaDiff-d66e183',
            topics: [],
        },
        {
            title: ' BuildUpdateSchemaDiff ',
            href: 'sm-builder-BuildUpdateSchemaDiff.html',
            attributes: { 'data-id': 'sm-builder-BuildUpdateSchemaDiff' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-BuildUpdateSchemaDiff-d66e191',
            topics: [],
        },
        {
            title: ' CheckTableExists ',
            href: 'sm-builder-CheckTableExists.html',
            attributes: { 'data-id': 'sm-builder-CheckTableExists' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-CheckTableExists-d66e199',
            topics: [],
        },
        {
            title: ' CreateDb ',
            href: 'sm-builder-CreateDb.html',
            attributes: { 'data-id': 'sm-builder-CreateDb' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-CreateDb-d66e207',
            topics: [],
        },
        {
            title: ' EvaluateJavaScript ',
            href: 'sm-builder-EvaluateJavaScript.html',
            attributes: { 'data-id': 'sm-builder-EvaluateJavaScript' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-EvaluateJavaScript-d66e215',
            topics: [],
        },
        {
            title: ' EvaluateJavaScriptTemplate ',
            href: 'sm-builder-EvaluateJavaScriptTemplate.html',
            attributes: { 'data-id': 'sm-builder-EvaluateJavaScriptTemplate' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-EvaluateJavaScriptTemplate-d66e224',
            topics: [],
        },
        {
            title: ' ExecSql ',
            href: 'sm-builder-ExecSql.html',
            attributes: { 'data-id': 'sm-builder-ExecSql' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-ExecSql-d66e232',
            topics: [],
        },
        {
            title: ' ExecSqlScript ',
            href: 'sm-builder-ExecSqlScript.html',
            attributes: { 'data-id': 'sm-builder-ExecSqlScript' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-ExecSqlScript-d66e240',
            topics: [],
        },
        {
            title: ' GenCreateDbDDL ',
            href: 'sm-builder-GenCreateDbDDL.html',
            attributes: { 'data-id': 'sm-builder-GenCreateDbDDL' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-GenCreateDbDDL-d66e248',
            topics: [],
        },
        {
            title: ' GenCreateOrUpdateSchemaSequenceDDL ',
            href: 'sm-builder-GenCreateOrUpdateSchemaSequenceDDL.html',
            attributes: { 'data-id': 'sm-builder-GenCreateOrUpdateSchemaSequenceDDL' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-GenCreateOrUpdateSchemaSequenceDDL-d66e256',
            topics: [],
        },
        {
            title: ' GenerateNavTree ',
            href: 'sm-builder-GenerateNavTree.html',
            attributes: { 'data-id': 'sm-builder-GenerateNavTree' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-GenerateNavTree-d66e264',
            topics: [],
        },
        {
            title: ' GenerateSchema ',
            href: 'sm-builder-GenerateSchema.html',
            attributes: { 'data-id': 'sm-builder-GenerateSchema' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-GenerateSchema-d66e272',
            topics: [],
        },
        {
            title: ' GetDbParams ',
            href: 'sm-builder-GetDbParams.html',
            attributes: { 'data-id': 'sm-builder-GetDbParams' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-GetDbParams-d66e280',
            topics: [],
        },
        {
            title: ' GetDefaultNamespace ',
            href: 'sm-builder-GetDefaultNamespace.html',
            attributes: { 'data-id': 'sm-builder-GetDefaultNamespace' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-GetDefaultNamespace-d66e288',
            topics: [],
        },
        {
            title: ' InstallPackage ',
            href: 'sm-builder-InstallPackage.html',
            attributes: { 'data-id': 'sm-builder-InstallPackage' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-InstallPackage-d66e296',
            topics: [],
        },
        {
            title: ' InstallPackageImpl ',
            href: 'sm-builder-InstallPackageImpl.html',
            attributes: { 'data-id': 'sm-builder-InstallPackageImpl' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-InstallPackageImpl-d66e304',
            topics: [],
        },
        {
            title: ' InstallVendorPackages ',
            href: 'sm-builder-InstallVendorPackages.html',
            attributes: { 'data-id': 'sm-builder-InstallVendorPackages' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-InstallVendorPackages-d66e313',
            topics: [],
        },
        {
            title: ' RemoveSchemaLinkRef ',
            href: 'sm-builder-RemoveSchemaLinkRef.html',
            attributes: { 'data-id': 'sm-builder-RemoveSchemaLinkRef' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-RemoveSchemaLinkRef-d66e321',
            topics: [],
        },
        {
            title: ' ResolvePackageReferences ',
            href: 'sm-builder-ResolvePackageReferences.html',
            attributes: { 'data-id': 'sm-builder-ResolvePackageReferences' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-ResolvePackageReferences-d66e329',
            topics: [],
        },
        {
            title: ' UpdateDb ',
            href: 'sm-builder-UpdateDb.html',
            attributes: { 'data-id': 'sm-builder-UpdateDb' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-UpdateDb-d66e337',
            topics: [],
        },
        {
            title: ' UpdateSchemaFromDatabase ',
            href: 'sm-builder-UpdateSchemaFromDatabase.html',
            attributes: { 'data-id': 'sm-builder-UpdateSchemaFromDatabase' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-UpdateSchemaFromDatabase-d66e345',
            topics: [],
        },
        {
            title: ' UpdateTempSchemasFromDatabase ',
            href: 'sm-builder-UpdateTempSchemasFromDatabase.html',
            attributes: { 'data-id': 'sm-builder-UpdateTempSchemasFromDatabase' },
            menu: { hasChildren: false },
            tocID: 'sm-builder-UpdateTempSchemasFromDatabase-d66e353',
            topics: [],
        },
    ],
};

